<template>
  <div
    class="grid"
    :class="[classes, compact ? 'gap-3' : large ? 'gap-12' : 'gap-6', fill ? null : 'content-start', custom]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: Number,
      default: 1
    },
    compact: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    custom: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      if (this.wide) {
        if (this.cols === 2) {
          return this.force ? 'grid-cols-2' : '@5xl:grid-cols-2'
        }
        if (this.cols === 3) {
          return this.force ? 'grid-cols-3' : '@3xl:grid-cols-2 @5xl:grid-cols-3'
        }
        if (this.cols === 4) {
          return this.force ? 'grid-cols-4' : '@3xl:grid-cols-2 @7xl:grid-cols-4'
        }
        if (this.cols === 5) {
          return this.force ? 'grid-cols-5' : '@3xl:grid-cols-2 @7xl:grid-cols-5'
        }
        if (this.cols === 6) {
          return this.force ? 'grid-cols-6' : '@3xl:grid-cols-2 @7xl:grid-cols-6'
        }
        if (this.cols === 8) {
          return this.force ? 'grid-cols-8' : '@3xl:grid-cols-2 @7xl:grid-cols-8'
        }
        if (this.cols === 10) {
          return this.force ? 'grid-cols-10' : '@3xl:grid-cols-2 @7xl:grid-cols-10'
        }
      }

      if (this.cols === 2) {
        return this.force ? 'grid-cols-2' : '@2xl:grid-cols-2'
      }
      if (this.cols === 3) {
        return this.force ? 'grid-cols-3' : '@2xl:grid-cols-2 @3xl:grid-cols-3'
      }
      if (this.cols === 4) {
        return this.force ? 'grid-cols-4' : '@2xl:grid-cols-2 @5xl:grid-cols-4'
      }
      if (this.cols === 5) {
        return this.force ? 'grid-cols-5' : '@2xl:grid-cols-2 @5xl:grid-cols-5'
      }
      if (this.cols === 6) {
        return this.force ? 'grid-cols-6' : '@2xl:grid-cols-2 @5xl:grid-cols-6'
      }
      if (this.cols === 8) {
        return this.force ? 'grid-cols-8' : '@3xl:grid-cols-2 @7xl:grid-cols-8'
      }
      if (this.cols === 10) {
        return this.force ? 'grid-cols-10' : '@3xl:grid-cols-2 @7xl:grid-cols-10'
      }

      return 'grid-cols-1'
    }
  }
}
</script>
